import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  signal,
} from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';
import { captureException } from '@sentry/angular';
import { ShiftsService } from '@wilson/shifts';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { catchError, finalize, map, of, switchMap } from 'rxjs';

@Component({
  selector: 'wilson-shift-violation-comment',
  templateUrl: './violation-comment.component.html',
  styleUrl: './violation-comment.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, NzSkeletonModule],
})
export class ViolationCommentComponent {
  private readonly shiftsService = inject(ShiftsService);

  readonly shiftId = input<string | null>(null);

  private readonly isLoadingSignal = signal(false);
  protected readonly isLoading = this.isLoadingSignal.asReadonly();

  protected readonly comment = toSignal(
    toObservable(this.shiftId).pipe(
      switchMap((shiftId) => {
        if (!shiftId) {
          this.isLoadingSignal.set(false);
          return of(null);
        }
        this.isLoadingSignal.set(true);
        return this.shiftsService.getShiftReport(shiftId).pipe(
          map((shiftReports) => shiftReports[0]?.comment ?? null),
          catchError((error) => {
            captureException(error);
            return of(null);
          }),
          finalize(() => this.isLoadingSignal.set(false)),
        );
      }),
    ),
    { initialValue: null },
  );
}
